// import React from 'react';
// import ReactDOM from 'react-dom';
// // import './index.css';
// import App from './App';
// // import * as serviceWorker from './serviceWorker';
// import { BrowserRouter } from "react-router-dom";
// import Menus from './menu'


import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { loadRemoteApps } from '../src/loadRemoteApplications';
import { useLastLocation } from 'react-router-last-location';
import { ClearCache } from "./ClearCacheNew";
import 'bootstrap/dist/css/bootstrap.min.css';
//import 'jquery/dist/jquery.min.js';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'popper.js';
//import {JqueryMenu} from './assets/js/ThemeFunctions';
import './assets/scss/style.scss';
import './assets/scss/ipd/index.scss';
import './assets/scss/ipd/patient_chart_summary.css';
import './assets/scss/ipd/medicine.scss';
import './assets/scss/ipd/patient-history.scss';
//import App from './App';
//import Menus from './menu';
import 'antd/dist/antd.css';
// react date-picer css
import "react-datepicker/dist/react-datepicker.css";
import 'Lims/scss/lims.scss'
import '../src/EMR/IPD/pages/CSSDScreens/scss/cssddesign.scss'
import 'Lims/LabDashboard/assets/scss/dashboardlims.scss'
import 'Lims/Transactions/patientTemplates/assets/scss/limswebreport.scss'
import "HomecareScreens/scss/newhomecare.scss"
import Axios from 'axios';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Provider } from 'react-redux';
import RedusStore from './RedusStore'
import * as serviceWorker from './serviceWorker';
import { authenticationService } from '../src/authorize/_services';
import ErrorBoundary from './ErrorBoundary';
// import * as AppAction from './AppAction/AppMstAction';
import LS_SERVICE from './utils/localStorage';
import {
  FETCH_IPD_LOGIN_DETAILS,
  GET_FACILITY_EMR_CONFIGURATION,
  FACILITY_EMR_STAFF_CONFIG
} from './utils/constant';
import * as gl from 'GlobalConfig';
import { importRemote } from '../src/utils/importRemote';
import loader from './assets/images/loader.gif';
import HelmetComponent from "./HelmetComponent"

// import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';
const AppComponent = React.lazy(() => import('./App'));
const MenuComponent = React.lazy(() => import('./menu'));
const isMenuNotRequired = document.URL.includes('investigation-images') || document.URL.includes('patient-key-findings') || document.URL.includes('patient-clinical-findings') || document.URL.includes('lims/order/critical-overview') || document.URL.includes('lims/investigation/overview') || document.URL.includes('ClinicalForms?source=opd') || document.URL.includes('OPDPACForm?source=opd');

if(document.URL.includes('ClinicalForms?source=opd') || document.URL.includes('OPDPACForm?source=opd')){
  const path = String(window.location.pathname).toLocaleLowerCase();
  FormsAutoLogin();
}

/*
 importRemote : This function will load all url from the rempote app in lazy fashion.
*/
loadRemoteApps().then(() => {
  importRemote('SunEditorStyles');
});
/*
 loadRemoteApps : This function will load all the remote apps in lazy fashion.
*/


async function FormsAutoLogin(){
  const queryParams = new URLSearchParams(document.URL);
  var doctor_id = queryParams.get('doctor_id');
  var facility_id = queryParams.get('facility_id');
  var enterprise_id = queryParams.get('enterprise_id');
  var token = queryParams.get('token');
  var role = queryParams.get('role_id');
  var enterprise_name = queryParams.get('enterprise_name');
  
  localStorage.setItem("sourceurl", document.URL);
  //localStorage.setItem("userId", doctor_id);
  localStorage.setItem('ADMITTING_PRACTITIONER_ID', doctor_id);
  localStorage.setItem('agentPortalToken', token)
  localStorage.setItem('agent_portal_staff_id', doctor_id);
  localStorage.setItem('HOSPITAL_ID', enterprise_id);
  localStorage.setItem('FACILITY_ID', facility_id);

  await Axios.get(GET_FACILITY_EMR_CONFIGURATION + '/' + facility_id + '/' + enterprise_id)
  .then(facilityConfigData => {
    if (facilityConfigData?.data?.status == true) {
      LS_SERVICE.set('EMR_CONFIGURATION_DATA', facilityConfigData?.data?.data || {});
    }
  }).catch(err => console.log(err))


  await Axios.post(FACILITY_EMR_STAFF_CONFIG, {
    facility_id: parseInt(facility_id),
    staff_id: parseInt(doctor_id),
  }).then(response => {
    if (response.data?.status) {
      LS_SERVICE.set('EMR_STAFF_CONFIGURATION_DATA', response.data?.data || {});
    }
  }).catch(err => console.log(err));

  
  if(!localStorage.getItem('menuItems') || !localStorage.getItem('pinnedMenu')){
    localStorage.setItem('setFrom', "OPEMR")
    let url = gl.CoreMasterAPI + '/ModulePages/GetOnlyModulePagesListMenu/' + parseInt(doctor_id) + '/' + parseInt(role) + '/' + parseInt(facility_id);
    await Axios.get(url).then(success => {
      var amModulePagesListViewModel = success?.data?.data?.amModulePagesListViewModel
      var am_module_page_pinnedViewModel = success?.data?.data?.am_module_page_pinnedViewModel;
      localStorage.setItem('menuItems', JSON.stringify(amModulePagesListViewModel))
      localStorage.setItem('pinnedMenu', JSON.stringify(am_module_page_pinnedViewModel))
    })
  }
  if(!localStorage.getItem('currentUser')){
    localStorage.setItem('setFrom', "OPEMR")
    await Axios.post(FETCH_IPD_LOGIN_DETAILS, {
      doctor_id: doctor_id,
      hospital_id: parseInt(facility_id)
    }).then(success => {
      var staff = success?.data?.data?.staff;
      var facility = success?.data?.data?.facility;
      LS_SERVICE.set('currentUser', {
        "roleId": parseInt(role),
        "facilityId":parseInt(facility_id),
        "userId": parseInt(doctor_id),
        "employeeData":{
          "id":parseInt(doctor_id),
          "titleName": staff.role_id == 3 ? "Dr." : "",
          "firstName": staff.first_name,
          "middleName": staff.middle_name,
          "lastName": staff.last_name,
          "employeeId": parseInt(doctor_id),
          "employeeName": staff.first_name,
          "userGroup": staff.role_id == 3 ? "DR" : "NU",
          "userGroupName": staff.role_id == 3 ? "Doctor" : "Nurse",
          "genderCode": staff.gender == "Male" ? "M" : "F",
          "employeeImage": staff.profile_picture,
          "enterpriseId": parseInt(enterprise_id),
          "facilityId": parseInt(facility_id),
          "userId":parseInt(doctor_id),
          "employee_email": staff.email,
          "employee_mobile": staff.mobile_no,
          "integrationid": doctor_id,
        },
        "facilityName": facility.name,
        "facilityImage": facility.hospital_image,
        "roleName": staff.role_id == 3 ? "Doctor" : "Nurse",
        "enterpriseName":enterprise_name,
        "enterpriseId": parseInt(enterprise_id),
        "facilityAddress":facility.address,
      });
    })
  }
  if(!localStorage.getItem('pageButtons') || !localStorage.getItem('pageSectionButtons') || !localStorage.getItem('pageSections') || !localStorage.getItem('pageFunction')){
    localStorage.setItem('setFrom', "OPEMR")
    let url = gl.CoreMasterAPI + '/ModulePages/GetUserCTAAndTokenData/' + parseInt(doctor_id) + '/' + parseInt(role) + '/' + parseInt(facility_id);
    await Axios.get(url).then(success => {
      var buttonViewModel = success?.data?.data?.buttonViewModel;
      var sectionButtonViewModel = success?.data?.data?.sectionButtonViewModel;
      var amModulePageSections = success?.data?.data?.amModulePageSections;
      var amModulePageFunctionPermissionViewModel = success?.data?.data?.amModulePageFunctionPermissionViewModel;
      localStorage.setItem('pageButtons', JSON.stringify(buttonViewModel))
      localStorage.setItem('pageSectionButtons', JSON.stringify(sectionButtonViewModel))
      localStorage.setItem('pageSections', JSON.stringify(amModulePageSections))
      localStorage.setItem('pageFunction', JSON.stringify(amModulePageFunctionPermissionViewModel))
    })
  }
}

ReactDOM.render(  

  <div className="container-fluid" >
    {/* {authenticationService.currentUserValue ? '' : window.location.href = '/signin'} */}
    <Provider store={RedusStore}>
      <BrowserRouter>
        <HelmetComponent />
        <Suspense fallback={
          <main>
            <div style={{ width: '100%', height: '100vh', background: 'rgba(255,255,255,.7)', borderRadius: '4px', overflow: "hidden", position: "absolute", zIndex: '999999' }} className="d-flex flex-column align-items-center justify-content-center">
              
               <img src={loader} width='70' />
              <p><strong>Loading..</strong></p>
             
            </div>
          </main>
        }>
          {/* {authenticationService.currentUserValue  ? <MenuComponent /> : <div style={{ width: '100vw', height: '100vh' }}></div>} */}
          {isMenuNotRequired ?
            null :
            <React.Fragment>
              {(authenticationService.currentUserValue) ?
                <MenuComponent /> :
                <div style={{ width: '100vw', height: '100vh' }}></div>}
            </React.Fragment>
          }

          <ErrorBoundary>
            {/* <ClearBrowserCacheBoundary auto={true} fallback='Clearing Browser Cache Loading..' duration={60000}>
             
            </ClearBrowserCacheBoundary> */}

            {/* <ClearCache> */}
              <AppComponent />
            {/* </ClearCache> */}
          </ErrorBoundary>
        </Suspense>


      </BrowserRouter>

    </Provider>
  </div>

  , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
